export default __webpack_public_path__ + "static/media/logo.0dc43db9.png";